import { call, put, all, select } from "redux-saga/effects";
import { 
  getSlug, 
  foreignProfilebrandInfo, 
  wardrobe, 
  fetchArts 
} from "../../../api";
import { profileActions } from "../../../actions/profile";

export function* loadProfilePage({ payload: { uid } }) {
  try {
    yield put(profileActions.changeIsLoadingProfile(true));

    let targetSlug = uid;
    
    // 1. Resolve Slug
    // Only attempt getSlug if uid is provided. 
    // If uid is null (my profile), we might rely on userInfo? 
    // But the action is dispatched with route param. 
    // If route param is undefined, it's "my profile". 
    // Users are redirected to /profile before this? No, /profile is a valid route.
    // If uid is undefined, "viewAs" implies "me".
    // If uid is missing, try to get it from auth reducer
    if (!uid) {
        const userInfo = yield select(state => state.authReducer.userInfo);
        if (userInfo) {
            targetSlug = userInfo.slug; 
        }
    }
    
    if (uid) {
       try {
           const { response } = yield call(getSlug, uid);
           if (response && response.slug) {
               targetSlug = response.slug;
           }
       } catch (e) {
            console.warn("getSlug failed, using uid as slug", e);
       }
    } 
    // If no UID was passed, targetSlug might still be null if not in auth. 
    // But we should have it from auth if logged in.


    // 2. Fetch Main Profile Data
    const { response: profile, error } = yield call(foreignProfilebrandInfo, targetSlug);

    if (profile) {
      // Add original uid so the UI can match short IDs to resolved slugs
      const profileWithUid = { ...profile, requestedUid: uid };
      // Update Core Profile Data
      yield put(profileActions.setProfileData(profileWithUid));
      yield put(profileActions.setProfileData({ ...profileWithUid, is_following: profile.is_following }));
      
      // 3. Parallel Fetch of Tab Content
      const effects = {
        wardrobe: call(wardrobe, targetSlug),
      };

      // If Brand, fetch Arts (and maybe Store/Spins?)
      // Check business_role structure. Usually truthy or specific string?
      // Original code: `if (foreignBrandInfo?.business_role)`
      if (profile.business_role) {
         effects.arts = call(fetchArts, targetSlug, 0);
         // You can add Shop/Store fetches here if needed for initial load
      }

      const results = yield all(effects);

      // 4. Handle Results
      if (results.wardrobe && results.wardrobe.response) {
        yield put(profileActions.fetchWardrobeProducts(targetSlug)); // Maintain potential side effects? 
        // Better: Dispatch Success directly
        yield put(profileActions.fetchWardrobeSucceeded(results.wardrobe.response.products));
      }

      if (results.arts && results.arts.response) {
         yield put(profileActions.fetchStartArtsProductsSucceed(results.arts.response));
      }

    } else {
       // Profile not found
       console.error("Profile not found", error);
       yield put(profileActions.setProfileError("PAGE_NOT_ACTIVE"));
    }

  } catch (err) {
    console.error("loadProfilePage saga error", err);
    yield put(profileActions.setProfileError("PAGE_NOT_ACTIVE"));
  } finally {
    yield put(profileActions.changeIsLoadingProfile(false));
  }
}
